import { useMemo } from "react";
import { HStack, Button } from "@chakra-ui/react";

import Select from "../Select/Select";
// import Button from "../Button/Button";
import Input from "./NumberInput";

export default function InputWithSelect(props) {
  const {
    isError,
    options,
    onSelect,
    onInput,
    selectValue,
    defaultSelectValue,
    inputValue,
    defaultInputValue,
    _select,
    _input,
    _inputContainer,
    _selectContainer,
    onMax,
    children,
    isMaxing,
    isMaxDisabled,
    ...xprops
  } = props;

  const dynamicStyles = useMemo(() => {
    const map = {
      error: {
        borderColor: "var(--errorTextColor)",
        sx: {
          ":focus-within": {
            borderColor: "var(--errorTextColor)",
            shadow: "0 0 0 3px var(--errorFocusColor)",
            transitionProperty: "var(--chakra-transition-property-common)",
            transitionDuration: "200ms",
          },
        },
      },
      default: {
        borderColor: "transparent",
        sx: {
          ":focus-within": {
            borderColor: "var(--primary)",
            shadow: "0 0 0 3px var(--focusColor)",
            transitionProperty: "var(--chakra-transition-property-common)",
            transitionDuration: "200ms",
          },
        },
      },
    };

    return map[isError ? "error" : "default"];
  }, [isError]);

  // console.log(
  //   `dSELECTED VALUE :: ${defaultSelectValue} - ${selectValue}\ndINPUT VALUE :: ${defaultInputValue}`
  // );

  const adornment = useMemo(() => {
    const map = {
      true: {
        // _input: {
        //   pr: "4.8rem",
        // },
        _endAdornment: {
          right: "10px",
          w: "56px",
        },
        endAdornment: (
          <Button
            isLoading={isMaxing}
            disabled={isMaxing || isMaxDisabled}
            px="12px"
            bg="var(--primary)"
            color="white"
            _focus={{
              shadow: "0 0 0 3px var(--focusColor)",
            }}
            onClick={onMax}
          >
            Max
          </Button>
        ),
      },
      false: {},
    };

    return map[String(!!onMax)];
  }, [onMax, isMaxDisabled, isMaxing]);

  return (
    <HStack
      border="1px solid transparent"
      borderColor="var(--borderColor)"
      justifyContent="center"
      alignItems="center"
      {...xprops}
      aria-label="input with select dropdown"
      //   transition="all .300ms ease-out"
      transitionProperty="var(--chakra-transition-property-common)"
      transitionDuration="200ms"
      borderRadius="16px"
      {...dynamicStyles}
    >
      <Select
        {..._select}
        minH="58px"
        borderRadius="15px 0px 0px 15px"
        _focus={{ shadow: "none", borderColor: "transparent" }}
        _container={{
          flex: 0.29,
          borderRight: "1px solid #6e719188",
          ..._selectContainer,
        }}
        defaultValue={defaultSelectValue ?? ""}
        value={selectValue ?? ""}
        onChange={onSelect}
      >
        {!children &&
          options?.map((option, i) => (
            <option key={`input-with-select-${i}`} value={option.value}>
              {option.label}
            </option>
          ))}

        {children && children}
      </Select>
      <Input
        flex={0.71}
        // minW="100%"

        minH="100%"
        // px=".8rem !important"
        // borderRadius="0px 16px 16px 0px"
        // _focus={{ shadow: "none", borderColor: "transparent" }}
        // _container={{
        //   flex: 0.71,
        //   ml: "0 !important",
        // }}

        ml="0 !important"
        _input={{
          px: ".8rem",
          pr: !!onMax ? "4.3rem" : ".8rem",
          minH: "58px",
          borderWidth: "0",
          borderRadius: "0px 15px 15px 0px",
          borderColor: "transparent",
          _focus: {
            shadow: "none",
          },

          ..._input,
        }}
        {...adornment}
        defaultValue={defaultInputValue}
        value={inputValue}
        onChange={onInput}
        {..._inputContainer}
      />
    </HStack>
  );
}
